import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaHome, FaList, FaFileAlt, FaUser, FaSignInAlt } from 'react-icons/fa';
import '../styles/navbar.css';

const Navbar = () => {
  return (
    <div className="navbar">
      <div className="logo-container">
        <img src="/images/logo.png" alt="Logo" className="navbar-logo" />
      </div>

      <NavLink to="/" className="nav-item" activeclassname="active">
        <FaHome />
        <span>Home</span>
      </NavLink>

      <NavLink to="/services" className="nav-item" activeclassname="active">
        <FaList />
        <span>Services</span>
      </NavLink>

      <NavLink to="/transactions" className="nav-item" activeclassname="active">
        <FaFileAlt />
        <span>Transactions</span>
      </NavLink>

      <NavLink to="/profile" className="nav-item" activeclassname="active">
        <FaUser />
        <span>Profile</span>
      </NavLink>

      <NavLink to="/login" className="nav-item" activeclassname="active">
        <FaSignInAlt />
        <span>Log In</span>
      </NavLink>
    </div>
  );
};

export default Navbar;
